export const CELL_TYPES = {
  DEFAULT: 0,
  PROGRESS: 1,
};
